import _asyncToGenerator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import "./chunk-PXG64RU4.js"; // src/infiniteQueryBehavior.ts

import { addToEnd, addToStart, ensureQueryFn } from "./utils.js";

function infiniteQueryBehavior(pages) {
  return {
    onFetch: function onFetch(context, query) {
      var _a, _b, _c, _d, _e;

      var options = context.options;
      var direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
      var oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
      var oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
      var result = {
        pages: [],
        pageParams: []
      };
      var currentPage = 0;

      var fetchFn = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var cancelled, addSignalProperty, queryFn, fetchPage, previous, pageParamFn, oldData, param, remainingPages, _oldPageParams$, _param;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                cancelled = false;

                addSignalProperty = function addSignalProperty(object) {
                  Object.defineProperty(object, "signal", {
                    enumerable: true,
                    get: function get() {
                      if (context.signal.aborted) {
                        cancelled = true;
                      } else {
                        context.signal.addEventListener("abort", function () {
                          cancelled = true;
                        });
                      }

                      return context.signal;
                    }
                  });
                };

                queryFn = ensureQueryFn(context.options, context.fetchOptions);

                fetchPage = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, param, previous) {
                    var queryFnContext, page, maxPages, addTo;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (!cancelled) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return", Promise.reject());

                        case 2:
                          if (!(param == null && data.pages.length)) {
                            _context.next = 4;
                            break;
                          }

                          return _context.abrupt("return", Promise.resolve(data));

                        case 4:
                          queryFnContext = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                          };
                          addSignalProperty(queryFnContext);
                          _context.next = 8;
                          return queryFn(queryFnContext);

                        case 8:
                          page = _context.sent;
                          maxPages = context.options.maxPages;
                          addTo = previous ? addToStart : addToEnd;
                          return _context.abrupt("return", {
                            pages: addTo(data.pages, page, maxPages),
                            pageParams: addTo(data.pageParams, param, maxPages)
                          });

                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));

                  return function fetchPage(_x, _x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                if (!(direction && oldPages.length)) {
                  _context2.next = 14;
                  break;
                }

                previous = direction === "backward";
                pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
                oldData = {
                  pages: oldPages,
                  pageParams: oldPageParams
                };
                param = pageParamFn(options, oldData);
                _context2.next = 11;
                return fetchPage(oldData, param, previous);

              case 11:
                result = _context2.sent;
                _context2.next = 23;
                break;

              case 14:
                remainingPages = pages !== null && pages !== void 0 ? pages : oldPages.length;

              case 15:
                _param = currentPage === 0 ? (_oldPageParams$ = oldPageParams[0]) !== null && _oldPageParams$ !== void 0 ? _oldPageParams$ : options.initialPageParam : getNextPageParam(options, result);

                if (!(currentPage > 0 && _param == null)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("break", 23);

              case 18:
                _context2.next = 20;
                return fetchPage(result, _param);

              case 20:
                result = _context2.sent;
                currentPage++;

              case 22:
                if (currentPage < remainingPages) {
                  _context2.next = 15;
                  break;
                }

              case 23:
                return _context2.abrupt("return", result);

              case 24:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));

        return function fetchFn() {
          return _ref.apply(this, arguments);
        };
      }();

      if (context.options.persister) {
        context.fetchFn = function () {
          var _a2, _b2;

          return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
            client: context.client,
            queryKey: context.queryKey,
            meta: context.options.meta,
            signal: context.signal
          }, query);
        };
      } else {
        context.fetchFn = fetchFn;
      }
    }
  };
}

function getNextPageParam(options, _ref3) {
  var pages = _ref3.pages,
      pageParams = _ref3.pageParams;
  var lastIndex = pages.length - 1;
  return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}

function getPreviousPageParam(options, _ref4) {
  var pages = _ref4.pages,
      pageParams = _ref4.pageParams;

  var _a;

  return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}

function hasNextPage(options, data) {
  if (!data) return false;
  return getNextPageParam(options, data) != null;
}

function hasPreviousPage(options, data) {
  if (!data || !options.getPreviousPageParam) return false;
  return getPreviousPageParam(options, data) != null;
}

export { hasNextPage, hasPreviousPage, infiniteQueryBehavior };